import { API_ENDPOINT } from '../common';

export function createFirmwareApi({ apiEndpoint = API_ENDPOINT, fetchImpl = fetch } = {}) {
  return {
    async getVersions(model) {
      const res = await fetchImpl(`${apiEndpoint}/firmware/versions?model=${model}`, { credentials: 'include' });
      if (!res.ok) return [];
      const data = await res.json();
      return data.versions || [];
    },
    async getLatestStable(model) {
      const stable = (await this.getVersions(model)).filter((v) => !v.prerelease);
      return stable.length ? stable[0].version : null;
    },
    async downloadBin(model, version) {
      const res = await fetchImpl(`${apiEndpoint}/firmware/download/${model}/v${version}.bin`, { credentials: 'include' });
      if (!res.ok) throw new Error(`Failed to download firmware v${version}: ${res.status}`);
      return new Uint8Array(await res.arrayBuffer());
    },
    async reportOutcome(event) {
      try {
        await fetchImpl(`${apiEndpoint}/firmware/telemetry/firmware-update`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(event),
        });
      } catch (_) {
        // best-effort; telemetry must never break the update flow
      }
    },
  };
}
